import AppPaths from "constants/appPaths";

// PRE-2837: where to go from a record deduplication merged into another (a link to it, from a comment
// or notification, opens a notice instead of the record): the record it was merged into, and the
// schema's Subsumed records, where a steward can restore it.
//   survivor: { dataObjectId, dataSetId, schemaId, businessAreaId } as the dataset service resolves it.
export function mergedRecordLinks({ tenant, businessArea, schema, schemaId, survivor }) {
    if (!survivor || !survivor.dataObjectId) {
        return { survivorId: null, subsumedPath: null };
    }
    const sameSchema = !survivor.schemaId || !schemaId || survivor.schemaId === schemaId;
    return {
        // Opened in place when it is in this schema (deduplication only merges within a dataset).
        survivorId: sameSchema ? survivor.dataObjectId : null,
        subsumedPath: `${AppPaths.TENANT_SCHEMA_REVIEW_QUEUE.replace(":tenant", tenant.toLowerCase())
            .replace(":businessarea", businessArea.toLowerCase())
            .replace(":schema", schema)}?view=subsumed`,
    };
}
